import React, { useState, useEffect } from 'react';
import Modal from '../common/Modal';
import Input from '../common/Input';
import Button from '../common/Button';
import { debtorService } from '../../services/debtorService';
import { useNotification } from '../../hooks/useNotification';

const EditDebtorModal = ({ isOpen, onClose, debtor, onSuccess }) => {
  const { showSuccess, showError } = useNotification();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    mobile: '',
    email: '',
    paymentPlan: 'none',
    notes: ''
  });

  useEffect(() => {
    if (debtor) {
      setFormData({
        name: debtor.name || '',
        mobile: debtor.mobile || '',
        email: debtor.email || '',
        paymentPlan: debtor.paymentPlan || 'none',
        notes: debtor.notes || ''
      });
    }
  }, [debtor]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await debtorService.update(debtor._id, formData);
      showSuccess('Debtor updated successfully!');
      onClose();
      if (onSuccess) onSuccess();
    } catch (error) {
      console.error('Error updating debtor:', error);
      showError(error.message || 'Failed to update debtor. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Edit Debtor">
      <form onSubmit={handleSubmit}>
        <Input
          label="Name"
          name="name"
          value={formData.name}
          onChange={handleChange}
          placeholder="Debtor's name"
          required
        />

        <Input
          label="Mobile Number"
          name="mobile"
          value={formData.mobile}
          onChange={handleChange}
          placeholder="+973 XXXXXXXX"
          required
        />

        <Input
          label="Email (Optional)"
          type="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          placeholder="debtor@example.com"
        />

        <div className="mb-4">
          <label htmlFor="paymentPlan" className="block text-sm font-medium text-gray-700 mb-1">
            Payment Plan
          </label>
          <select
            id="paymentPlan"
            name="paymentPlan"
            value={formData.paymentPlan}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500"
          >
            <option value="none">No Payment Plan</option>
            <option value="weekly">Weekly</option>
            <option value="biweekly">Bi-weekly</option>
            <option value="monthly">Monthly</option>
            <option value="custom">Custom</option>
          </select>
        </div>

        <div className="mb-4">
          <label htmlFor="notes" className="block text-sm font-medium text-gray-700 mb-1">
            Notes (Optional)
          </label>
          <textarea
            id="notes"
            name="notes"
            value={formData.notes}
            onChange={handleChange}
            placeholder="Add any notes..."
            rows="3"
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500"
          />
        </div>

        <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-4">
          <p className="text-sm text-yellow-800">
            <strong>Note:</strong> You can only edit name, mobile, email, and notes. Transaction totals cannot be changed here.
          </p>
        </div>

        <div className="flex gap-3 justify-end">
          <Button type="button" variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button type="submit" loading={loading}>
            Save Changes
          </Button>
        </div>
      </form>
    </Modal>
  );
};

export default EditDebtorModal;
